export const CommonMelbourneData = [
  {
    title: "Immigration Documents",
    detail:
      "About 190,000 immigrants enter Melbourne every year, and it's increasing yearly. Our translators are familiar with applications for visas, green cards, and permanent residencies, among others. If you're thinking about applying for immigration, your financial, housing, and other documents may need to be translated. Choose Tomedes today.",
    link: "/uscis-translation-services",
  },
  {
    title: "University Documents",
    detail:
      "Your university may have specific requirements that necessitate you to send in a myriad of documents. These university documents, such as transcripts, letters of recommendation, and other application documents may need to be translated. They may even need certified translations. So reach out now.",
    link: "/transcript-translation-services",
  },
  {
    title: "Business Documents",
    detail:
      "Documents are an essential part of running a business or making a business a global one. Whether it's your legal documents for your firm, your marketing materials, your HR documents, we can translate it. You're assured that your global operations will run smoothly with translation services. Contact us now.",
    link: "/business-translation.php",
  },
  {
    title: "Other Essential Documents",
    detail:
      "Thinking about translating your new book or your driver's license? Whichever translation service you need, we can broaden your horizons by providing you with solutions for your language problems. The reach of your book or the success of your driver's license application could lie in translation. Get started.",
    link2: "/contactus.php",
  },
];
